<template>
  <div class="forgetPwdModal">
    <!-- 忘记密码弹窗 -->
    <Modal v-model="showForgetTip" ok-text="发送验证码" title="找回密码" :mask-closable="false" @on-ok="confirmForgetCode"
      @on-cancel="cancelForgetCode" :loading="$root.$children[0].modalLoading" width="500" class="my-modal login-modal">
      <Form label-position="top" ref="formValidate" :model="formForget" :rules="ruleValidate" style="margin-top:20px">
        <FormItem label="您的手机号" prop="mobile">
          <Input size="large" v-model="formForget.mobile" placeholder="请输入手机号"></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 重置密码弹窗 -->
    <Modal :mask-closable="false" v-model="showForget" title="重置密码" @on-ok="confirmForget" @on-cancel="cancelForget"
      :loading="$root.$children[0].modalLoading" width="620" class="resetPass my-modal login-modal">
      <Form ref="formValidateReset" :model="formForgetReset" :rules="ruleValidateReset" :label-width="0"
        style="padding-top:20px">
        <FormItem>
          验证码已发送至您的手机:
          <span style="font-weight:bold">{{ formForget.mobile }}</span>
        </FormItem>
        <FormItem prop="code">
          <span class="icon icon-auth preIcon"></span>
          <Input autocomplete size="large" v-model="formForgetReset.code" placeholder="请输入您的验证码"></Input>
          <Button size="large" type="primary" @click="confirmForgetCode" :disabled="!!codeTimer">{{ timeTxt }}</Button>
        </FormItem>
        <FormItem prop="password">
          <span class="icon icon-password preIcon"></span>
          <Input size="large" v-model="formForgetReset.password" placeholder="请输入新密码"></Input>
        </FormItem>
        <div>注：新密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种</div>
      </Form>
    </Modal>
    <validCodeModal class-name="forget-valid"  ref="validCodeModal" @success="validCode"></validCodeModal>
  </div>
</template>

<script>
import validCodeModal from "./validCodeModal";
export default {
  props: [],
  components: { validCodeModal },
  data() {
    return {
      count: 60, //验证码时间倒计时
      timer: '', //验证码时间定时器
      showForget: false,
      showForgetTip: false,
      codeTimer: null,
      timeTxt: '点击发送',
      baseUrl: '',
      formForgetReset: {
        code: '',
        password: ''
      },
      formForget: {
        mobile: ''
      },
      ruleValidateReset: {
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          {
            trigger: 'blur',
            pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,16}$/,
            message: '新密码格式不正确'
          }
        ]
      },
      ruleValidate: {
        mobile: [
          { required: true, message: '请输入您的手机号', trigger: 'blur' },
          { pattern: /^1[1023456789]\d{9}$/, message: '请输入正确的手机号' }
        ]
      },
    };
  },
  watch: {},
  destroyed() {
    window.clearInterval(this.timer);
    clearInterval(this.codeTimer);
    this.codeTimer = null;
    this.timeTxt = '重新发送';
  },
  methods: {
    open() {
      this.$refs.formValidate.resetFields();
      this.showForgetTip = true;
    },
    //修改密码
    changePassword() {
      const { code, password } = this.formForgetReset;
      const { mobile } = this.formForget;
      this.$http({
        url: '/system/info/resetPassWordByForget',
        type: 'post',
        data: {
          mobile,
          code,
          password
        }
      }).then(res => {
        this.$Message.success('修改成功');
        this.showForget = false;
      });
    },

    //重置密码
    confirmForget() {
      this.$units.notCloseModal(this);
      this.$refs.formValidateReset.validate(valid => {
        if (valid) {
          this.changePassword();
        }
      });
    },
    cancelForget() {
      clearInterval(this.codeTimer);
      this.codeTimer = null;
      this.timeTxt = '重新发送';
    },
    timerDown() {
      if (this.timer) return;
      let time = 60;
      this.codeTimer = setInterval(() => {
        time--;
        this.timeTxt = '重新发送' + '（' + time + 's）';
        if (time <= 0) {
          clearInterval(this.codeTimer);
          this.codeTimer = null;
          this.timeTxt = '重新发送';
        }
      }, 1000);
    },
    //确认手机号
    confirmForgetCode() {
      this.$units.notCloseModal(this);
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          //  alert(true)
          //显示图形验证码校验
          //显示重置密码弹窗

          this.$refs.validCodeModal.open(
            {
              params: {
                mobile: this.formForget.mobile,
                loginType:2,
              },
              requestUrl: '/system/info/sendCodeByForget',//请求地址
            }
          );
        }
      });
    },
    validCode(code) {
      this.formForget.code = code;
      this.timerDown();
      this.showForget = true;
      this.$refs.formValidateReset.resetFields();
      this.showForgetTip = false;

    },
    cancelForgetCode() {
      clearInterval(this.codeTimer);
      this.codeTimer = null;
      this.timeTxt = '重新发送';
    },
  },
};
</script>
